// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3SYJ8","containerItemsCenter":"Skeleton_containerItemsCenter__nj4PL"};